import { Box } from "@mui/material";
import { RequestCard } from "./RequestCard";
import { useNavigate } from "react-router-dom";
import { useUserInfoMeStore } from "@src/entities/user/model/store/userInfoMeStore";
import userImage from "@src/shared/assets/user.svg";
import settingsImage from "@src/shared/assets/settings.svg";

import styles from "./RequestCards.module.scss";

//добавить переход на страницу ранжирования

export const RequestCards = () => {
  const navigate = useNavigate();
  const userMe = useUserInfoMeStore((state) => state.user);
  const userImg = <img src={userImage} className={styles.img} />;
  const settingsImg = <img src={settingsImage} className={styles.img} />;

  const attemptsUsed = userMe?.matching_requests || 0;

  const handleFirst = () => {
    navigate("/creating-search");
  };

  // const handleSecond = () => {
  //   console.log("Ранжировать резюме clicked");
  // };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 3,
        alignItems: "stretch",
        flexWrap: "wrap",
        mt: 4,
      }}
    >
      <RequestCard
        title="Подобрать кандидатов на вакансию"
        processedNumber={attemptsUsed}
        icon={userImg}
        onClick={handleFirst}
        ariaLabel="Подобрать кандидатов"
      />
      <RequestCard
        title="Ранжировать резюме под вакансию"
        processedNumber={0}
        icon={settingsImg}
        ariaLabel="Ранжировать резюме"
      />
    </Box>
  );
};
